<div class="row">
	<div class="col-sm-12">
		<app-textblock-list-filters
			#listfilters
			[searchparams]="advancedSearch"
			[tenderid]="tenderid">
		</app-textblock-list-filters>

	</div>
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				class="float-right btn btn-sm btn-primary"
				(click)="edit()">
				<i
					container="body"
					ngbTooltip="{{'labels.create' | translate}}"
					class="feather icon-plus"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					[rowClass]="rowClass"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					[messages]="{
          emptyMessage: 'labels.empty-textblock' | translate,
          totalMessage: 'labels.total' | translate
		}">

					<ngx-datatable-column
						prop="entity"
						[flexGrow]="1"
						[name]="'labels.entity' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{'types.textblock-types.'+ value | translate}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="name"
						[flexGrow]="4.5"
						[name]="'labels.name' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="sort"
						[flexGrow]="0.5"
						[name]="'labels.sort' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column [flexGrow]="0.3">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div>
								<i
									*ngIf="row.mandatory"
									[ngbTooltip]="('labels.mandatory' | translate)"
									class="fas fa-asterisk"></i>
							</div>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="insdate"
						[flexGrow]="0.8"
						[name]="'labels.insdate' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="moddate"
						[flexGrow]="0.8"
						[name]="'labels.moddate' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							{{value | date: 'dd/MM/yyyy' }}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">

								<a
									(click)="edit(row.id)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.edit' | translate}}"
										class="feather icon-edit"></i>
								</a>
								<a
									(click)="delete(row, $event)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>
